export default "__VITE_ASSET__Dl6sN3QK__"